// extracted by mini-css-extract-plugin
export default {"root":"qqWv_","coin":"uSYgE","amount":"rBA6W"};